import { BBVATheme } from "./themes/BBVATheme";
import { THEME_NAMES } from "./themes/config";
import { nemuruTheme } from "./themes/nemuruTheme";
import { testuruTheme } from "./themes/testuruTheme";
import { realTurfTheme } from "./themes/realTurfTheme";
import { caixabankTheme } from "./themes/caixabankTheme";
import { cochesnetTheme } from "./themes/cochesnetTheme";
import { citiserviTheme } from "./themes/citiserviTheme";
import { smartfyTheme } from "./themes/smartfyTheme";
import { proinsoTheme } from "./themes/proinsoTheme";
import { astaraTheme } from "./themes/astaraTheme";
import { assetPackIds } from "nemuru-components";
import { carrefourTheme } from "./themes/carrefourTheme";
import { upfTheme } from "./themes/upfTheme";
import { peralbaTheme } from "./themes/peralbaTheme";
import { telefonicaTheme } from "./themes/telefonicaTheme";
import { esadeTheme } from "./themes/esadeTheme";
import { sunheroTheme } from "./themes/sunheroTheme";
import { iberiaTheme } from "./themes/iberiaTheme";
import { vaillantTheme } from "./themes/vaillantTheme";
import { saunierDuvalTheme } from "./themes/saunierDuvalTheme";
import { hofmannTheme } from "./themes/hofmannTheme";
import { ventajonTheme } from "./themes/ventajonTheme";
import { thePowerTheme } from "./themes/thePowerTheme";
import { santanderTheme } from "./themes/santanderTheme";
import { demoTheme } from "./themes/demoTheme";
import { ktuinTheme } from "./themes/ktuinTheme";
import { farmaLeadersTalentoTheme } from "./themes/farmaLeadersTalento";
import { inventarioProTheme } from "./themes/inventarioProTheme";
import { pontioTheme } from "./themes/pontioTheme";
import { flashDataAcademyTheme } from "./themes/flashDataAcademy";
import { mbSelectorTheme } from "./themes/mbSelectorTheme";
import { quadisTheme } from "./themes/quadisTheme";
import { lisaInstituteTheme } from "./themes/lisaInstituteTheme";
import { formacionUniversitariaTheme } from "./themes/formacionUniversitariaTheme";
import { momentumTheme } from "./themes/momentumTheme";
import { dcoreTheme } from "./themes/dcoreTheme";

export const neutralTheme = {
  themeName: THEME_NAMES.neutral,
  palette: {
    primary: {
      main: "#3E6AE1",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#b8b8b8",
      contrastText: "#1A1A1A",
    },
    dark: {
      main: "#eaeaea",
      contrastText: "#525252",
      accent: "#525252",
    },
    text: {
      title: "#1A1A1A",
      primary: "#555555",
      secondary: "#77787b",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  customBorderRadius: {
    button: 25,
    paper: 15,
  },
  typography: {
    fontFamily:
      'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
  shadows: [
    "none",
    "none",
    "none", // 2 buttons
    "none", // 3 papers soft
  ],
};

export const customThemes = {
  [THEME_NAMES.nemuru]: nemuruTheme,
  [THEME_NAMES.testuru]: testuruTheme,
  [THEME_NAMES.real_turf]: realTurfTheme,
  [THEME_NAMES.caixabank]: caixabankTheme,
  [THEME_NAMES.cochesnet]: cochesnetTheme,
  [THEME_NAMES.citiservi]: citiserviTheme,
  [THEME_NAMES.smartfy]: smartfyTheme,
  [THEME_NAMES.proinso]: proinsoTheme,
  [THEME_NAMES.BBVATheme]: BBVATheme,
  [THEME_NAMES.carrefour]: carrefourTheme,
  [THEME_NAMES.astara]: astaraTheme,
  [THEME_NAMES.upf]: upfTheme,
  [THEME_NAMES.peralba]: peralbaTheme,
  [THEME_NAMES.telefonica]: telefonicaTheme,
  [THEME_NAMES.esade]: esadeTheme,
  [THEME_NAMES.sunhero]: sunheroTheme,
  [THEME_NAMES.iberia]: iberiaTheme,
  [THEME_NAMES.vaillant]: vaillantTheme,
  [THEME_NAMES.saunier_duval]: saunierDuvalTheme,
  [THEME_NAMES.hofmann]: hofmannTheme,
  [THEME_NAMES.ventajon]: ventajonTheme,
  [THEME_NAMES.the_power]: thePowerTheme,
  [THEME_NAMES.santander]: santanderTheme,
  [THEME_NAMES.ktuin]: ktuinTheme,
  [THEME_NAMES.farma_leaders_talento]: farmaLeadersTalentoTheme,
  [THEME_NAMES.flash_data_academy]: flashDataAcademyTheme,
  [THEME_NAMES.demo]: demoTheme,
  [THEME_NAMES.inventario_pro]: inventarioProTheme,
  [THEME_NAMES.pontio]: pontioTheme,
  [THEME_NAMES.mb_selector]: mbSelectorTheme,
  [THEME_NAMES.quadis]: quadisTheme,
  [THEME_NAMES.lisa_institute]: lisaInstituteTheme,
  [THEME_NAMES.formacion_universitaria]: formacionUniversitariaTheme,
  [THEME_NAMES.momentum]: momentumTheme,
  [THEME_NAMES.dcore]: dcoreTheme,
};
